import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { useNavigate } from "react-router-dom";

function Setup() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    erp_status: "Active",
    user_name: "",
    password: "",
    login_api: "",
    post_api: "",
    naming_series: "",
    company: "",
    company_id: "",
    debit_to: "",
    erp_account: "",
    income_account: "",
    charge_type: "",
    expense_account: "",
    uom: "",
    cost_center: "",
    item_code: "",
    currency: "",
    taxes_and_charges: "",
    pos_profile: "",
    is_pos: "",
    selling_price_list: "",
    write_off_account: "",
    write_off_cost_center: "",
    paid_status: "",
    language: "",
    mode_of_payment: "",
  });

  useEffect(() => {
    axios
      .get(`${apiKey}/api/erp-settings`)
      .then((res) => {
        if (res.data.status && res.data.data) {
          const d = res.data.data;
          setFormData({
            erp_status: d.erp_status || "Active",
            user_name: d.user_name || "",
            password: d.password || "",
            login_api: d.login_api || "",
            post_api: d.post_api || "",
            naming_series: d.naming_series || "",
            company: d.company || "",
            company_id: d.company_id || "",
            debit_to: d.debit_to || "",
            erp_account: d.erp_account || "",
            income_account: d.income_account || "",
            charge_type: d.charge_type || "",
            expense_account: d.expense_account || "",
            uom: d.uom || "",
            cost_center: d.cost_center || "",
            item_code: d.item_code || "",
            currency: d.currency || "",
            taxes_and_charges: d.taxes_and_charges || "",
            pos_profile: d.pos_profile || "",
            is_pos: d.is_pos || "",
            selling_price_list: d.selling_price_list || "",
            write_off_account: d.write_off_account || "",
            write_off_cost_center: d.write_off_cost_center || "",
            paid_status: d.paid_status || "",
            language: d.language || "",
            mode_of_payment: d.mode_of_payment || "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to fetch ERP settings");
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    axios
      .post(`${apiKey}/api/erp-settings/store`, formData)
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message || "Failed to save ERP settings");
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          const errors = err.response.data.errors;
          for (let key in errors) {
            if (errors.hasOwnProperty(key)) {
              toast.error(errors[key][0]);
            }
          }
        } else {
          toast.error("An error occurred while saving settings");
        }
        console.log(err);
      });
  };

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-[#7B20C7] text-2xl">ERP Setup</h1>
        </div>
        <div className="w-full">
          <form
            className="w-full"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            {/* ERP Status */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">
              <label className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 font-bold">
                  ERP Status
                </span>
                <div className="mb-2 pt-0">
                  <label className="mr-4">
                    <input
                      type="radio"
                      name="erp_status"
                      value="Active"
                      checked={formData.erp_status === "Active"}
                      onChange={handleChange}
                    />{" "}
                    Active
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="erp_status"
                      value="Inactive"
                      checked={formData.erp_status === "Inactive"}
                      onChange={handleChange}
                    />{" "}
                    Inactive
                  </label>
                </div>
              </label>
            </div>

            {/* User & Password */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              {/* User */}
              <label className="w-full">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 font-bold">
                  User
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="user_name"
                    value={formData.user_name}
                    onChange={handleChange}
                    placeholder="Imdady Demo Account"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              {/* Password */}
              <label className="w-full">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 font-bold">
                  Password
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="*****"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            {/* Login & Post API (same UI, now bound) */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full ">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Login Api
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="login_api"
                    value={formData.login_api}
                    onChange={handleChange}
                    placeholder="http://13.234.93.196/api/method/login"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full ">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Post Api
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="post_api"
                    value={formData.post_api}
                    onChange={handleChange}
                    placeholder="http://13.234.93.196/api/resource/Sales Invoice"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            {/* naming_series, company, company_id, debit_to */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  naming_series
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="naming_series"
                    value={formData.naming_series}
                    onChange={handleChange}
                    placeholder="ACC-SINV-.YYYY.-"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  company
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Imdady RMS"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  company_id
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="company_id"
                    value={formData.company_id}
                    onChange={handleChange}
                    placeholder="IR"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  debit_to
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="debit_to"
                    value={formData.debit_to}
                    onChange={handleChange}
                    placeholder="1310 - مدينون -"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>
            </div>

            {/* erp_account, income_account, charge_type, expense_account */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  erp_account
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="erp_account"
                    value={formData.erp_account}
                    onChange={handleChange}
                    placeholder="1110 - نقد"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  income_account
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="income_account"
                    value={formData.income_account}
                    onChange={handleChange}
                    placeholder="4110 - مبيعات -"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  charge_type
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="charge_type"
                    value={formData.charge_type}
                    onChange={handleChange}
                    placeholder="On Net Total"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  expense_account
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="expense_account"
                    value={formData.expense_account}
                    onChange={handleChange}
                    placeholder="5111 - تكلفة البضاعة المباعة -"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>
            </div>

            {/* uom, cost_center, item_code, currency */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w/full pt-3">
              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  uom
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="uom"
                    value={formData.uom}
                    onChange={handleChange}
                    placeholder="Nos"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  cost_center
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="cost_center"
                    value={formData.cost_center}
                    onChange={handleChange}
                    placeholder="رئيسي "
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  item_code
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="item_code"
                    value={formData.item_code}
                    onChange={handleChange}
                    placeholder="10004"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  currency
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="currency"
                    value={formData.currency}
                    onChange={handleChange}
                    placeholder="SAR"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>
            </div>

            {/* taxes_and_charges, pos_profile, is_pos, selling_price_list */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w/full pt-3">
              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  taxes_and_charges
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="taxes_and_charges"
                    value={formData.taxes_and_charges}
                    onChange={handleChange}
                    placeholder="KSA VAT 15% - "
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  pos_profile
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="pos_profile"
                    value={formData.pos_profile}
                    onChange={handleChange}
                    placeholder="IR POS PROFILE "
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  is_pos
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="is_pos"
                    value={formData.is_pos}
                    onChange={handleChange}
                    placeholder="1"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  selling_price_list
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="selling_price_list"
                    value={formData.selling_price_list}
                    onChange={handleChange}
                    placeholder="البيع القياسية"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>
            </div>

            {/* write_off_account, write_off_cost_center, paid_status, language */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w/full pt-3">
              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  write_off_account
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="write_off_account"
                    value={formData.write_off_account}
                    onChange={handleChange}
                    placeholder="4110 - مبيعات - "
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  write_off_cost_center
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="write_off_cost_center"
                    value={formData.write_off_cost_center}
                    onChange={handleChange}
                    placeholder="رئيسي "
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  paid_status
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="paid_status"
                    value={formData.paid_status}
                    onChange={handleChange}
                    placeholder="Paid"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  language
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="language"
                    value={formData.language}
                    onChange={handleChange}
                    placeholder="Arabic"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>
            </div>

            {/* mode_of_payment */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w/full pt-3">
              <label htmlFor="" className="w/full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  mode_of_payment
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="mode_of_payment"
                    value={formData.mode_of_payment}
                    onChange={handleChange}
                    placeholder=""
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w/full"
                  />
                </div>
              </label>
            </div>

            <span className="w/full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                type="submit"
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg"
              >
                Submit
              </button>
              <button
                type="button"
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default Setup;
